import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SectionHeaderComponent } from '@app/widgets';
import { environment } from '@env/environment';
import { TuiButton } from '@taiga-ui/core';

@Component({
  selector: 'app-native-builds-how-it-works-section',
  imports: [SectionHeaderComponent, TuiButton],
  templateUrl: './native-builds-how-it-works-section.component.html',
  styleUrl: './native-builds-how-it-works-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NativeBuildsHowItWorksSectionComponent {
  protected readonly consoleBaseUrl = environment.consoleBaseUrl;
  protected readonly docsUrl =
    'https://capawesome.io/cloud/native-builds/setup/';
}
